import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { DriverQuestion } from '../models/questionnaire/driver-question.model';

@Injectable()
export class QuestionsCaptureCommunicationService {
    /**
     * Emitters being used to send question answers to the proper child component
     * mapped from their driver question type id.
     */
    private emitters: { [key: number]: Subscriber<any> } = {};

    /**
     * Observables currently listening for answers mapped from their driver question type id.
     */
    private observables: { [key: number]: Observable<any> } = {};

    /**
     * Sends an answer for the question to any listeners.
     *
     * @param question The question the answer is for.
     * @param answer The answer to the question.
     */
    public sendAnswer = (question: DriverQuestion, answer: any): void => {
        let emitter = this.emitters[question.id];

        if (!emitter) {
            throw new Error(`No emitter for question type id ${question.id}.`);
        }

        emitter.next(answer);
    };

    /**
     * Watches answer changes for the given question.
     *
     * @param question The question to listen for changes on.
     * @returns An observable that emits the new answer.
     */
    public watchAnswerChanges = (question: DriverQuestion): Observable<any> => {
        let observable = this.observables[question.id];

        if (!observable) {
            observable = new Observable<any>((observer) => {
                this.emitters[question.id] = observer;
            });
        }

        return observable;
    };
}
